.photo {
  animation: property-link-photo-zoom 20s ease-in-out infinite;
}

@keyframes property-link-photo-zoom {
  0%,
  100% {
    transform: scale(1.12);
  }
  50% {
    transform: scale(1.04);
  }
}

@media (prefers-reduced-motion: reduce) {
  .photo {
    animation: none;
    transform: scale(1.04);
  }
}
